// extracted by mini-css-extract-plugin
module.exports = {"OnlineInvo":"Onlinelnvoicing_OnlineInvo__1UYYM","OnlineInvo_header":"Onlinelnvoicing_OnlineInvo_header__2FCeK"};